import ChangePassword from "../Components/ChangePassword";
import {useDispatch, useSelector} from "react-redux";
import fireAjax from "../services";
import {toast} from 'react-toastify';
import {logoutRequest} from "../redux/actions";
import history from "../History";

export default function UserChangePassword() {

    const dispatch = useDispatch()
    const loginData = useSelector(state => state.auth.loginData)

    const onSubmitHandler = (currentPassword, newPassword, newPasswordConfirmation) => {
        const apiResponse = fireAjax("POST", "users/admin/changePassword",
            undefined, {
                "email": loginData.currentUser.email,
                currentPassword,
                newPassword,
                newPasswordConfirmation
            })

        apiResponse.then(response => {
            toast.success(response.data.message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            dispatch(logoutRequest());
        }).catch(error => {
            console.log("error", error.response.data.message)
            toast.error(error.response.data.message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        })
    }

    return (
        <ChangePassword onSubmit={onSubmitHandler}/>
    )
}